module.exports = __webpack_public_path__ + "img/x2.00f56ea7.png";